import { SearchOptionsRequest } from "src/app/shared/models/SearchOptionsRequest.model";
import { PaymentType } from "../enums/payment-type.enum";

export class ContactSearchOptionsRequest extends SearchOptionsRequest {
  tags: number[] = [];
  fundraisingId = 0;
  contactReferrerId = 0;
  excludeAgentContacts = false;
  isBaseSearch: boolean;
  paymentType: PaymentType = PaymentType.None
}
